import * as FlightSortFilter from './components/FlightSortFilter.css';
export default {
    FlightSortFilter
};
